import { Dispatcher } from "@aux4/dispatcher.js";
import { MESSAGE } from "./Events";

export function displayMessage(message) {
  Dispatcher.dispatch(MESSAGE, message);
}
